import React, { useState, useEffect, useContext, useRef } from "react";
import { DataGrid, gridClasses } from "@mui/x-data-grid";

import { useParams, Link, useNavigate } from "react-router-dom";

import update from "immutability-helper";
import FormControlLabel from "@mui/material/FormControlLabel";
import ArrowRightIcon from "@mui/icons-material/ArrowRight";
import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";
import EditTeamResourceNoteDialog from "./EditTeamResourceNoteDialog";
import { REFRESH_TOKEN_MUTATION } from "../../graphQL/user_qry";
import { GET_TERM_TEAMS_QUERY } from "../../graphQL/team_term_qry";
import { GET_ALL_MEMBERS_IN_TEAM_TERM_QUERY,
} from "../../graphQL/team_term_member_qry";
import {
  useQuery,
  useManualQuery,
  useMutation,
  ClientContext,
} from "graphql-hooks";

import {
  Container,
  Card,
  CardContent,
  Grid,
  Typography,
  Divider,
  TextField,
  Radio,
  Checkbox,
  Tooltip,
  Button,
  IconButton,
  Dialog,
  DialogTitle,
  DialogActions,
  DialogContent,
  DialogContentText,
  FormHelperText,
  makeStyles,
} from "@material-ui/core";
import MenuItem from "@mui/material/MenuItem";
import Select from "@mui/material/Select";
import Box from "@mui/material/Box";
import styled from "styled-components";
import penImg from "../../assets/icons/pen.png";

import Header from "../terms/Header.js";
import AlertDialog from "../../components/AlertDialog.js";
import CheckIcon from "@mui/icons-material/Check";
import CloseIcon from "@mui/icons-material/Close";
import EditOutlinedIcon from "@mui/icons-material/EditOutlined";
import { project_url } from "../../constants/Data";

var findAnd = require("find-and");

const StyledTooltip = styled(props => (
  <Tooltip
    classes={{ popper: props.className }}
    {...props}
    PopperProps={{
      popperOptions: {
        modifiers: {
          flip: { enabled: false },
          offset: {
            offset: "0px, -50px, 20px, -25px",
          },
        },
      },
    }}
  />
))`
  & .MuiTooltip-tooltip {
    display: flex;
    background: #757575;
    color: #fff;
    border-radius: 4px;
    font-size: 10px;
    font-weight: 500;
  }
`;

const useStyles = makeStyles((theme) => ({
  root: {
    marginRight: "8rem",
    //textAlign: "center",
    padding: theme.spacing(2),
    paddingLeft: 0,
    paddingRight: 0,
    width: "1400px",
    paddingTop: "7rem",
    //  minWidth: "500px",
  },
  container: {
    padding: theme.spacing(4),
    marginTop: "1rem",
    marginBottom: "5rem",
    overflow: "hidden",
    clear: "both",
    borderRadius: "8px",
    minHeight: "870px",
    backgroundColor: "#ffffff",
  },
  outlinedButtonStyle: {
    borderRadius: 8,
    width: "110px",
    padding: 0,
    height: "48px",
    textTransform: "none",
  },
  selectStyle: {
    minWidth: 250,
    height: 35,
    //  paddingLeft: 16,
    marginBottom: 25,
    "& .MuiOutlinedInput-input": {
      textAlign: "left",
    },
  },
  errorStyle: {
    marginTop: 0,
    fontSize: 14, //16,
    fontFamily: "Arial",
  },
  buttonStyle: {
    borderRadius: 4,
    width: "250px",
    padding: 0,
    color: "#fff",
    height: "40px",
    backgroundColor: "#0D47A1",
    textTransform: "none",
    "&:hover": {
      backgroundColor: "#1E88E5",
    },
  },
    root: {
    marginRight: "8rem",
    //textAlign: "center",
    padding: theme.spacing(2),
    paddingLeft: 0,
    paddingRight: 0,
    width: "1400px",
    paddingTop: "7rem",
    //  minWidth: "500px",
  },
  textFieldStyle: {
    // height: 55,
    // marginBottom: 5,
    "& .MuiInputLabel-outlined": {
      fontSize: 16,
    },
    "& .MuiOutlinedInput-root": {
      height: 45,
      borderRadius: 10,
      fontSize: 16,
    },
  },
  iconStyle: {
    marginLeft: 12,
    height: 18,
    padding: 10,
    display: "flex",
    alignItems: "center",
    border: "1px solid lightGray",
    borderRadius: "4px",
    cursor: "pointer",
    "&:hover": {
      backgroundColor: "#EEEEEE",
    },
  },
}));

function TeamsResourcesNotes() {
  const { termUuid } = useParams();
  const [termName, setTermName] = useState("");
  const [termLink, setTermLink] = useState(null);
  const [loadContent, setLoadContent] = useState(false);
  const client = useContext(ClientContext);
  const navigate = useNavigate();
  const [pathname] = useState(window.location.pathname);
  const [termInfo, setTermInfo] = useState([]);
  const [selectedTeamTermMember, setSelectedTeamTermMember] = useState(null);
  const [membersInTeamTerm, setMembersInTeamTerm] = useState([]);
  const [currentTeamResourceData, setCurrentTeamResourceData] = useState([]);
  const [openEditTeamResourceNoteDialog, setOpenEditTeamResourceNoteDialog] = useState(false);
  const [members, setMembers] = useState([]);
  const [staffs, setStaffs] = useState([]);

  const [fetchTermTeams] = useManualQuery(GET_TERM_TEAMS_QUERY, {
    fetchPolicy: "network-only",
  });

  const [fetchTeamTermMemers] = useManualQuery(GET_ALL_MEMBERS_IN_TEAM_TERM_QUERY, {
    fetchPolicy: "network-only",
  });

  const [refreshToken] = useMutation(REFRESH_TOKEN_MUTATION, {
    onError: (err) => {
      console.log(err);
    },
  });
  
  useEffect(() => {
    if (localStorage.getItem("refreshToken")) {
      onRefreshToken();
    } else window.location.href = `${project_url}/signin/?next=${pathname}`;
  }, []);

  const onRefreshToken = async () => {
    const { data: refreshData, error: refreshError } = await refreshToken({
      variables: { refreshToken: localStorage.getItem("refreshToken") },
    });
    if (refreshError) {
      if (
        refreshError.graphQLErrors[0].message ===
        "You do not have permission to perform this action"
      )
        window.location.href = `${project_url}/signin/?next=${pathname}`;
      if (refreshError.graphQLErrors[0].message === "Signature has expired")
        window.location.href = `${project_url}/signin/?next=${pathname}`;
    }
    if (refreshData && refreshData.refreshToken) {
      localStorage.setItem("token", refreshData.refreshToken.token);
      localStorage.setItem(
        "refreshToken",
        refreshData.refreshToken.refreshToken
      );
      client.setHeader(
        "Authorization",
        `JWT ${refreshData.refreshToken.token}`
      );
      setLoadContent(true);
    }
  };

  const formatter1 = new Intl.DateTimeFormat("en-us", {
    weekday: "long",
    year: "numeric",
    month: "long",
    day: "numeric",
    hour: "numeric",
    minute: "numeric",
    second: "numeric",
    fractionalSecondDigits: 3,
    hour12: true,
    timeZoneName: "short",
  });

  const formatter2 = new Intl.DateTimeFormat("en-us", {
    year: "numeric",
    month: "2-digit",
    day: "2-digit",
  });

  const dayFormat = (day, format = null) => {
    const dayDate = new Date(day);
    const dayFormat = format!== null 
                      ? 
                        formatter1.formatToParts(dayDate)
                      :
                        formatter2.formatToParts(dayDate)
                      ;    
    if (format === "DDmonthYYYY") {
      const newFormat =
        dayFormat.find((a) => a.type == "weekday").value +
        ", " +
        dayFormat.find((a) => a.type == "day").value +
        " " +
        dayFormat.find((a) => a.type == "month").value +
        ", " +
        dayFormat.find((a) => a.type == "year").value;
      return newFormat;
    } else if (format === "monthDDYYYY") {
      const newFormat =
        dayFormat.find((a) => a.type == "month").value +
        " " +
        dayFormat.find((a) => a.type == "day").value +
        ", " +
        dayFormat.find((a) => a.type == "year").value;
      return newFormat;
    } else if (format === "YYYYmonthDD"){
      const newFormat =
        dayFormat.find((a) => a.type == "weekday").value +
        ", " +
        dayFormat.find((a) => a.type == "year").value +
        ", " +
        dayFormat.find((a) => a.type == "month").value +
        " " +
        dayFormat.find((a) => a.type == "day").value;
      return newFormat;
    } else {
      const newFormat =
        dayFormat.find((a) => a.type == "month").value +
        "/" +
        dayFormat.find((a) => a.type == "day").value +
        "/" +
        dayFormat.find((a) => a.type == "year").value;
      return newFormat;
    }
  };

  const getTermTeams = async () => {
    if (termUuid){      
      // Get term information
      const {
        loading: termTeamLoading,
        error: termTeamError,
        data: termTeamData,
      } = await fetchTermTeams({
        variables: { termUuid: termUuid },
      });

      if (!termTeamLoading && termTeamData && termTeamData.getTermTeams) {
        setTermInfo(termTeamData.getTermTeams);
        setTermLink(`${project_url}/terms/${termUuid}`);
        if(termTeamData.getTermTeams.length > 0){
            setTermName(termTeamData.getTermTeams[0].termId.name);
            setSelectedTeamTermMember(termTeamData.getTermTeams[0].teamTermId);
            getTeamTermMemers(termTeamData.getTermTeams[0].teamTermId);
        }
      }
      if (
        termTeamError &&
        termTeamError.graphQLErrors &&
        termTeamError.graphQLErrors[0].message === "Signature has expired"
      ) {
        navigate(`${project_url}/signin`);
      }

      if (
        termTeamError &&
        termTeamError.graphQLErrors &&
        termTeamError.graphQLErrors[0].message === "Term matching query does not exist."
      ) 
      {
        alert('Are you sure you have valid URL?');
      }           
    }
    else
    {
      alert('Are you sure you have valid URL?');
    }
  };

  useEffect(() => {
    (() => getTermTeams())();
  }, []);
  
  const handleChangeValue = async (event) => {
    const teamTermId = event.target.value;
    setSelectedTeamTermMember(teamTermId);
    getTeamTermMemers(teamTermId);
  };
  
  const getTeamTermMemers = async (teamTermId) => {
    if (teamTermId){      
      // Get member information
      const {
        loading: termTeamMemberLoading,
        error: termTeamMemberError,
        data: termTeamMemberData,
      } = await fetchTeamTermMemers({
        variables: { teamTermId: parseInt(teamTermId) },
      });

      if (!termTeamMemberLoading && termTeamMemberData && termTeamMemberData.getAllMembersInTeamTerm) {
        setMembersInTeamTerm(termTeamMemberData.getAllMembersInTeamTerm);
      }
      if (
        termTeamMemberError &&
        termTeamMemberError.graphQLErrors &&
        termTeamMemberError.graphQLErrors[0].message === "Signature has expired"
      ) {
        navigate(`${project_url}/signin`);
      }         
    }
    else
    {
      alert('Are you sure you have valid URL?');
    }
  };

  const classes = useStyles();
  const columns = [
    {
      field: "resourceName",
      headerName: "Resource Name",
      headerClassName: "super-app-theme--header",
      minWidth: 70,
      flex: 1,
      sortable: false,
      disableColumnMenu: true,
      colSpan: (value, row) => {
        if (row.index === 0) {
          return 6;
        }
        if (row.index === members.length + 1) {
          return 6;
        }
        return undefined;
      },
      renderCell: (rows) => {        
        if (rows.row.index === 0) {
          if (members.length){
            return (
              <>
                <Typography
                  style={{ 
                    paddingRight: 5, 
                    paddingBottom: 2,
                    paddingTop: 15,
                    fontSize: 16,
                    fontWeight: 700,
                  }}
                  variant="h2"
                >
                  Members
                </Typography>
              </>
            );
          }
          else
          {
            return (
              <>
                <Box
                  mt={0.5}
                  mb={1}
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    justifyContent: "start",
                  }}
                >
                <Typography
                  style={{ 
                    fontSize: 16,
                    fontWeight: 700,
                    paddingBottom: 2,
                  }}
                  variant="h2"
                >
                  Members
                </Typography>
                <Typography
                  style={{ 
                    paddingTop: 2,
                    fontSize: 14,
                    fontWeight: 500,
                  }}
                  variant="h2"
                >
                  No member is assigned to this team.
                </Typography>
                </Box>
              </>
            );
          }
        }
        else if (rows.row.index === members.length + 1) {
          if (staffs.length){
            return (
              <>
                <Typography
                  style={{ 
                    paddingRight: 5, 
                    paddingBottom: 2,
                    paddingTop: 15,
                    fontSize: 16,
                    fontWeight: 700,
                  }}
                  variant="h2"
                >
                  Staff
                </Typography>
              </>
            );
          }
          else
          {
            return (
              <>
                <Box
                  mt={0.5}
                  mb={1}
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    justifyContent: "start",
                  }}
                >
                <Typography
                  style={{ 
                    fontSize: 16,
                    fontWeight: 700,
                    paddingBottom: 2,
                  }}
                  variant="h2"
                >
                  Staff
                </Typography>
                <Typography
                  style={{ 
                    paddingTop: 2,
                    fontSize: 14,
                    fontWeight: 500,
                  }}
                  variant="h2"
                >
                  No staff is assigned to this team.
                </Typography>
                </Box>
              </>
            );
          }
        };
      },
    },
    {
      field: "role",
      headerName: "Role",
      headerClassName: "super-app-theme--header",
      minWidth: 10,
      flex: 1,
      sortable: false,
      disableColumnMenu: true,
    },
    {
      field: "completed",
      headerName: "Sprint Completed?",
      headerClassName: "super-app-theme--header",
      align: "center",
      minWidth: 5,
      flex: 1,
      sortable: false,
      headerAlign: "center",
      disableColumnMenu: true,
    },
    {
      field: "note",
      headerName: "Note",
      headerClassName: "super-app-theme--header",
      minWidth: 90,
      flex: 1,
      sortable: false,
      headerAlign: "center",
      disableColumnMenu: true,
    },
    {
      field: "lastUpdated",
      headerName: "Last Updated",
      headerClassName: "super-app-theme--header",
      minWidth: 5,
      flex: 1,
      sortable: false,
      headerAlign: "center",
      disableColumnMenu: true,
    },
    {
      field: "action",
      headerName: "Actions",
      headerClassName: "super-app-theme--header",
      minWidth: 2,
      flex: 1,
      sortable: false,
      align: "center",
      headerAlign: "center",
      disableColumnMenu: true,
      renderCell: rows => {
          return (
                 <StyledTooltip title="Update resource note">
                  <img
                    style={{
                      paddingRight: 10,
                      paddingTop: 6,
                      height: 24,
                      weight: 24,
                      cursor: "pointer",
                    }}
                    src={penImg}
                    onClick={() => {
                      setCurrentTeamResourceData(rows.row);
                      setOpenEditTeamResourceNoteDialog(true);
                    }}
                  />
           </StyledTooltip>
         )
       },
    },
  ];

  const [rows, setRows] = useState([]);
  useEffect(() => {
      let staffs = membersInTeamTerm
      .filter(resource => resource.userTypeId.typeName === "Staff")
      .map((resource, index) => ({
        id: resource.teamTermMemberId,
        resourceName: resource.userId.firstName + " " + resource.userId.lastName,
        role: resource.roleId.roleName,
        completed: resource.completed === false ? "No" : "Yes",
        note: resource.note,
        lastUpdated: resource.noteUpdateBy ? (dayFormat(resource.noteUpdateDate, "monthDDYYYY") + " - " + resource.noteUpdateBy.split(":")[1]) : "",
      }));
      setStaffs(staffs);

    let members = membersInTeamTerm
      .filter(resource => resource.userTypeId.typeName === "Member")
      .map((resource, index) => ({
        id: resource.teamTermMemberId,
        resourceName: resource.userId.firstName + " " + resource.userId.lastName,
        role: resource.roleId.roleName,
        completed: resource.completed === false ? "No" : "Yes",
        note: resource.note,
        lastUpdated: resource.noteUpdateBy ? (dayFormat(resource.noteUpdateDate, "monthDDYYYY") + " - " + resource.noteUpdateBy.split(":")[1]) : "",
      }));
      setMembers(members);
      
    let rows = [];
    //first row with col span
    rows.push({
      index: 0,
      resourceName: "",
      role: "",
      completed: "",
      note: "",
      lastUpdated: "", 
    });
    
    
    for (var i = 0; i < members.length; i++) {
      let row = [];
      row["index"] = i + 1;
      row["id"] = members[i].id;
      row["resourceName"] = members[i].resourceName;
      row["role"] = members[i].role;
      row["completed"] = members[i].completed;
      row["note"] = members[i].note;
      row["lastUpdated"] = members[i].lastUpdated;
      rows.push({
        index: row.index,
        id: row.id,
        resourceName: row.resourceName,
        role: row.role,
        completed: row.completed,
        note: row.note,
        lastUpdated: row.lastUpdated,       
      });      
    };

    // row for staffs label with col span
    rows.push({
      index: members.length + 1,
      resourceName: "",
      role: "",
      completed: "",
      note: "",
      lastUpdated: "",
    });
    

    for (var j = 0; j < staffs.length; j++) {
      let row = [];
      row["index"] = j + members.length + 2;
      row["id"] = staffs[j].id;
      row["resourceName"] = staffs[j].resourceName;
      row["role"] = staffs[j].role;
      row["completed"] = staffs[j].completed;
      row["note"] = staffs[j].note;
      row["lastUpdated"] = staffs[j].lastUpdated;
      rows.push({
        index: row.index,
        id: row.id,
        resourceName: row.resourceName,
        role: row.role,
        completed: row.completed,
        note: row.note,
        lastUpdated: row.lastUpdated,        
      });      
    };
    
    if (members.length || staffs.length){
      setRows(rows);
    }
    else
    {
      setRows([]);
    };
  }, [membersInTeamTerm]);


  
  function DataGridTitle() {
    return (
      <>
        <Grid
          container
          xs={12}
          style={{
            paddingTop: 5,
            paddingBottom: 6,
            width: "100%",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <Grid item xs={12} style={{ textAlign: "center" }}>
            <Typography variant="h1" style={{ fontSize: 20 }}>
              Teams Resources Note
            </Typography>
          </Grid>
        </Grid>
        <Divider />
        <Box
            pt={2}
            style={{
              display: "flex",
              flexDirection: "row",
              alignItems: "left",
            }}
          >
            <Typography style={{ marginLeft: 5, marginRight: 3 }} variant="h4">
              Term:
            </Typography>
            <Typography variant="h5">
              {termName}
            </Typography>
          </Box>
          <Box
            style={{
              display: "flex",
              flexDirection: "row",
              alignItems: "left",
            }}
          >
            <Typography style={{ marginLeft: 5 }} variant="h4">
              Teams:
            </Typography>
            <Box pl={1} mt={2}>
              <Select
                className={classes.selectStyle}
                value={selectedTeamTermMember}
                margin="normal"
                onChange={handleChangeValue}
              >
                {termInfo.map((teamTerm, index) => (
                  <MenuItem key={index} value={teamTerm.teamTermId}>
                    {teamTerm.teamId.name}
                  </MenuItem>
                ))}
              </Select>
            </Box>
          </Box>
        <Divider />
      </>
    );
  }

  if (loadContent)
    return (
      <div className={classes.root}>
        <Header
          breadcrumbs={[
            { label: termName, link: termLink },
            { label: "Teams Resources Note", link: null },
          ]}
        />
        <div className={classes.container}>
          <Box style={{ height: 372 }}>
            <DataGrid
              className={classes.dataGridStyle}
              columns={columns}
              rows={rows}
              showCellRightBorder={true}
              hideFooter={true}
              //autoWidth={true}
              autoHeight={true}
              getRowId={(row) => row.index}
              
              getCellClassName={(rows) => {
                if (rows.row.index === 0) return "colSpan";
                if (rows.row.index === members.length + 1) return "colSpan";
              }}
              experimentalFeatures={{ newEditingApi: true }}              
              slots={{
                toolbar: DataGridTitle,
                noRowsOverlay: () => (
                  <div style={{ padding: "20px", textAlign: "center" }}>
                    No member or staff is assigned to this team.
                  </div>
                ),
              }}
            />
          </Box>
        </div>
       {openEditTeamResourceNoteDialog && (
          <EditTeamResourceNoteDialog
            teamTermMemberId={currentTeamResourceData.id}
            closeDialog={() => {
              setOpenEditTeamResourceNoteDialog(false);
              getTeamTermMemers(selectedTeamTermMember);
            }}
          />
        )}
      </div>
    );
  else return;
}

export default TeamsResourcesNotes;
